require( `./index.scss` );
var throttle = require( 'lodash.throttle' );

const MAX_VIDEO_WIDTH = 600;

$( ()=>{
	console.log( 'Hey fellow developer! Get out of my code and into my comedy.' );
	fixMovies();
	addNavListener();
	$( window ).on( 'resize', throttle( fixMovies, 150 ) );
} );

function addNavListener() {
	$( '.nav a' ).on( 'click', function(){
		var goal = $( this ).attr( 'href' );
		if( goal.charAt( 0 ) !== '#' ) {
			return;
		}
		goal = goal.slice( 1 );
		var dest = $( 'h2' ).filter( function(){
			return $( this ).text().toLowerCase().trim() === goal;
		} );
		$( 'html, body' ).animate( {
			scrollTop: $( dest ).offset().top
		}, 700 );
	} );
}

function fixMovies() {
	// Resize all of the iframes to fit the window
	$( 'iframe' ).each( function() {
		var $this = $( this );
		var width = $this.width();
		var height = $this.height();
		$this.css( {
			'width': '100%',
			'max-width': `${MAX_VIDEO_WIDTH}px`
		} );
		var newWidth = $this.width();
		$this.css( {
			'width': '',
			'max-width': ''
		} );
		var newHeight = newWidth * ( height / width );

		$( this ).attr( 'height', newHeight );
		$( this ).attr( 'width', newWidth );
	} );
}



// WEBPACK FOOTER //
// ./client/index.js